/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDirectoryResponseFromDiscriminatorValue, createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, type DirectoryResponse, type HttpValidationProblemDetails, type IError } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /directories/root
 */
export interface RootRequestBuilder extends BaseRequestBuilder<RootRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DirectoryResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DirectoryResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RootRequestBuilderUriTemplate = "{+baseurl}/directories/root";
/**
 * Metadata for all the requests in the request builder.
 */
export const RootRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RootRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDirectoryResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
